// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menupage__container {

}
.menupage__row--one {
display: grid;
grid-template-columns: repeat(2, minmax(0, 1fr));
padding: 1.5rem
}
form {
display: grid;
grid-template-columns: repeat(3, minmax(0, 1fr));
align-items: center;
gap: 1.5rem;
border-radius: 0.375rem;
--tw-bg-opacity: 1;
background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
padding: 1.5rem
}
input {
grid-column: span 2 / span 2;
width: 100%;
border-radius: 0.375rem;
--tw-bg-opacity: 1;
background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
padding-top: 0.5rem;
padding-bottom: 0.5rem;
padding-left: 0.75rem;
padding-right: 0.75rem;
letter-spacing: 0.025em;
--tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
--tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
outline: 2px solid transparent;
outline-offset: 2px
}
.btn {
border-radius: 0.375rem;
--tw-bg-opacity: 1;
background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
padding-top: 0.5rem;
padding-bottom: 0.5rem;
font-weight: 600;
text-transform: uppercase;
letter-spacing: 0.025em;
--tw-text-opacity: 1;
color: rgb(255 255 255 / var(--tw-text-opacity, 1));
--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
--tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
transition-property: all;
transition-delay: 100ms;
transition-duration: 100ms;
transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
.btn:hover {
--tw-bg-opacity: 1;
background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
--tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
--tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
--tw-drop-shadow: drop-shadow(0 0 #0000);
filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.menupage__row--two {
display: grid;
grid-template-columns: repeat(3, minmax(0, 1fr));
padding: 1.5rem
}
.menupage__row--two ul {
grid-column: span 2 / span 2
}
.menupage__row--two ul li {
margin-bottom: 1rem;
display: flex;
cursor: pointer;
align-items: center;
justify-content: space-between;
border-radius: 0.375rem;
--tw-bg-opacity: 1;
background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
padding-left: 1.5rem;
padding-right: 1.5rem;
padding-top: 0.75rem;
padding-bottom: 0.75rem;
text-transform: capitalize;
letter-spacing: 0.025em;
--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
.menupage__row--two ul li:last-child {
margin-bottom: 0px
}
.btns__wrapper {
display: flex;
align-items: center;
gap: 1rem
}
.duplicate__btn {
cursor: pointer;
border-radius: 9999px;
--tw-bg-opacity: 1;
background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
padding: 0.75rem;
--tw-text-opacity: 1;
color: rgb(255 255 255 / var(--tw-text-opacity, 1));
--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
transition-property: all;
transition-delay: 100ms;
transition-duration: 100ms;
transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
@supports (color: rgb(0 0 0 / 0)) {
.duplicate__btn {
--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)
}
}
.duplicate__btn:hover {
--tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
--tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
--tw-drop-shadow: drop-shadow(0 0 #0000);
filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.edit__btn {
cursor: pointer;
border-radius: 9999px;
--tw-bg-opacity: 1;
background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
padding: 0.75rem;
--tw-text-opacity: 1;
color: rgb(255 255 255 / var(--tw-text-opacity, 1));
--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
transition-property: all;
transition-delay: 100ms;
transition-duration: 100ms;
transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
@supports (color: rgb(0 0 0 / 0)) {
.edit__btn {
--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)
}
}
.edit__btn:hover {
--tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
--tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
--tw-drop-shadow: drop-shadow(0 0 #0000);
filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}
.delete__btn {
cursor: pointer;
border-radius: 9999px;
--tw-bg-opacity: 1;
background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
padding: 0.75rem;
--tw-text-opacity: 1;
color: rgb(255 255 255 / var(--tw-text-opacity, 1));
--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
transition-property: all;
transition-delay: 100ms;
transition-duration: 100ms;
transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}
@supports (color: rgb(0 0 0 / 0)) {
.delete__btn {
--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)
}
}
.delete__btn:hover {
--tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
--tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
--tw-drop-shadow: drop-shadow(0 0 #0000);
filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}`, "",{"version":3,"sources":["webpack://./src/pages/MenuPage/menuPage.css"],"names":[],"mappings":"AAAA;;AAEA;AAEI;AAAA,aAA2B;AAA3B,gDAA2B;AAA3B;AAA2B;AAG3B;AAAA,aAAkE;AAAlE,gDAAkE;AAAlE,mBAAkE;AAAlE,WAAkE;AAAlE,uBAAkE;AAAlE,kBAAkE;AAAlE,4DAAkE;AAAlE;AAAkE;AAGlE;AAAA,4BAAiG;AAAjG,WAAiG;AAAjG,uBAAiG;AAAjG,kBAAiG;AAAjG,4DAAiG;AAAjG,mBAAiG;AAAjG,sBAAiG;AAAjG,qBAAiG;AAAjG,sBAAiG;AAAjG,uBAAiG;AAAjG,gDAAiG;AAAjG,6DAAiG;AAAjG,uGAAiG;AAAjG,8BAAiG;AAAjG;AAAiG;AAGjG;AAAA,uBAAyN;AAAzN,kBAAyN;AAAzN,0DAAyN;AAAzN,mBAAyN;AAAzN,sBAAyN;AAAzN,gBAAyN;AAAzN,yBAAyN;AAAzN,uBAAyN;AAAzN,oBAAyN;AAAzN,mDAAyN;AAAzN,0EAAyN;AAAzN,8FAAyN;AAAzN,uGAAyN;AAAzN,mGAAyN;AAAzN,iLAAyN;AAAzN,wBAAyN;AAAzN,uBAAyN;AAAzN,0BAAyN;AAAzN;AAAyN;AAAzN;AAAA,kBAAyN;AAAzN,0DAAyN;AAAzN,gDAAyN;AAAzN,6DAAyN;AAAzN,uGAAyN;AAAzN,wCAAyN;AAAzN;AAAyN;AAGzN;AAAA,aAA2B;AAA3B,gDAA2B;AAA3B;AAA2B;AAG3B;AAAA;AAAiB;AAGjB;AAAA,mBAAuI;AAAvI,aAAuI;AAAvI,eAAuI;AAAvI,mBAAuI;AAAvI,8BAAuI;AAAvI,uBAAuI;AAAvI,kBAAuI;AAAvI,4DAAuI;AAAvI,oBAAuI;AAAvI,qBAAuI;AAAvI,oBAAuI;AAAvI,uBAAuI;AAAvI,0BAAuI;AAAvI,uBAAuI;AAAvI,+EAAuI;AAAvI,mGAAuI;AAAvI;AAAuI;AAAvI;AAAA;AAAuI;AAGvI;AAAA,aAA8B;AAA9B,mBAA8B;AAA9B;AAA8B;AAG9B;AAAA,eAA2K;AAA3K,qBAA2K;AAA3K,kBAA2K;AAA3K,2DAA2K;AAA3K,gBAA2K;AAA3K,oBAA2K;AAA3K,mDAA2K;AAA3K,+EAA2K;AAA3K,mGAA2K;AAA3K,8FAA2K;AAA3K,uGAA2K;AAA3K,wBAA2K;AAA3K,uBAA2K;AAA3K,0BAA2K;AAA3K;AAA2K;AAA3K;AAAA;AAAA;AAA2K;AAAA;AAA3K;AAAA,gDAA2K;AAA3K,6DAA2K;AAA3K,uGAA2K;AAA3K,wCAA2K;AAA3K;AAA2K;AAG3K;AAAA,eAA0K;AAA1K,qBAA0K;AAA1K,kBAA0K;AAA1K,2DAA0K;AAA1K,gBAA0K;AAA1K,oBAA0K;AAA1K,mDAA0K;AAA1K,+EAA0K;AAA1K,mGAA0K;AAA1K,8FAA0K;AAA1K,uGAA0K;AAA1K,wBAA0K;AAA1K,uBAA0K;AAA1K,0BAA0K;AAA1K;AAA0K;AAA1K;AAAA;AAAA;AAA0K;AAAA;AAA1K;AAAA,gDAA0K;AAA1K,6DAA0K;AAA1K,uGAA0K;AAA1K,wCAA0K;AAA1K;AAA0K;AAG1K;AAAA,eAAyK;AAAzK,qBAAyK;AAAzK,kBAAyK;AAAzK,4DAAyK;AAAzK,gBAAyK;AAAzK,oBAAyK;AAAzK,mDAAyK;AAAzK,+EAAyK;AAAzK,mGAAyK;AAAzK,8FAAyK;AAAzK,uGAAyK;AAAzK,wBAAyK;AAAzK,uBAAyK;AAAzK,0BAAyK;AAAzK;AAAyK;AAAzK;AAAA;AAAA;AAAyK;AAAA;AAAzK;AAAA,gDAAyK;AAAzK,6DAAyK;AAAzK,uGAAyK;AAAzK,wCAAyK;AAAzK;AAAyK","sourcesContent":[".menupage__container {\n\n}\n.menupage__row--one {\n    @apply p-6 grid grid-cols-2;\n}\nform {\n    @apply p-6 rounded-md bg-white grid grid-cols-3 items-center gap-6;\n}\ninput {\n    @apply w-full outline-none col-span-2 py-2 px-3 shadow-inner bg-gray-100 rounded-md tracking-wide;\n}\n.btn {\n    @apply bg-green-500 py-2 rounded-md tracking-wide uppercase shadow text-white font-semibold transition-all ease-in-out duration-100 delay-100 hover:bg-green-500 drop-shadow-md hover:drop-shadow-none hover:shadow-inner;\n}\n.menupage__row--two{\n    @apply p-6 grid grid-cols-3;\n}\n.menupage__row--two ul {\n    @apply col-span-2;\n}\n.menupage__row--two ul li {\n    @apply px-6 py-3 rounded-md bg-white mb-4 last:mb-0 shadow-lg cursor-pointer capitalize tracking-wide flex items-center justify-between;\n}\n.btns__wrapper {\n    @apply flex items-center gap-4;\n}\n.duplicate__btn {\n    @apply text-white bg-green-400 p-3 rounded-full cursor-pointer shadow-lg shadow transition-all ease-in-out duration-100 delay-100 hover:drop-shadow-none hover:shadow-inner;\n}\n.edit__btn {\n    @apply text-white bg-blue-400 p-3 rounded-full cursor-pointer shadow-lg shadow transition-all ease-in-out duration-100 delay-100 hover:drop-shadow-none hover:shadow-inner;\n}\n.delete__btn {\n    @apply text-white bg-red-400 p-3 rounded-full cursor-pointer shadow-lg shadow transition-all ease-in-out duration-100 delay-100 hover:drop-shadow-none hover:shadow-inner;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
